import { environment } from 'src/environments/environment';

export const usercentricsDraftPreview = environment.USERCENTRICS_DRAFT_PREVIEW_ENABLED || false;
export const usercentricsSettingsId = environment.USERCENTRICS_SETTINGS_ID || 'ExBTOhsk7';
